import CryptoJS from "crypto-js";
import { formatNumber } from "layout/styles/global";
import { removeFormat } from "layout/styles/global";
import env from "utils/env";

export const EncryptString = (plainText) => {
  return CryptoJS.AES.encrypt(plainText, env.secret);
};

export const DecryptString = (cipherText) => {
  return CryptoJS.AES.decrypt(cipherText, env.secret);
};

export const getCurrentTimeInSecond = () => Math.round(Date.now() / 1000);

/* export const CalculateKala = (kalaItem) => {
  //if (kalaItem.kalaPrice.value === undefined) return kalaItem;
  let price = removeFormat(kalaItem.kalaPrice.value) * kalaItem.kalaTedad.value;
  let priceAfter = price - removeFormat(kalaItem.priceDiscount.value);
  let priceArzesh = (kalaItem.arzeshAfzodeh * price) / 100;

  kalaItem.priceBeforeDiscount = formatNumber(price.toString());
  kalaItem.priceAfterDiscount = formatNumber(priceAfter.toString());
  kalaItem.priceTaxArzeshAfzodeh = formatNumber(priceArzesh.toString());

  if (kalaItem.kalaName.mablaghSayerTax)
    kalaItem.priceSayerTaxAvarez = formatNumber(
      kalaItem.kalaName.mablaghSayerTax.toString()
    );

  if (kalaItem.kalaName.mablaghSayerGhanooni)
    kalaItem.priceSayerGhanoni = formatNumber(
      kalaItem.kalaName.mablaghSayerGhanooni.toString()
    );

  let priceTotal =
    priceArzesh +
    priceAfter +
    kalaItem.kalaName.mablaghSayerGhanooni +
    kalaItem.kalaName.mablaghSayerTax;
  kalaItem.priceTotal = formatNumber(priceTotal.toString());
  return kalaItem;
}; */
 export const CalculateKala = (kalaItem) => {
  let price =
    removeFormat(kalaItem.kalaPrice.value) * kalaItem.kalaTedad.value;

  let priceAfter = price - removeFormat(kalaItem.priceDiscount.value);

  let priceArzesh = (kalaItem.arzeshAfzodeh * price) / 100;

  kalaItem.priceBeforeDiscount = formatNumber(price.toString());
  kalaItem.priceAfterDiscount = formatNumber(priceAfter.toString());
  kalaItem.priceTaxArzeshAfzodeh = formatNumber(priceArzesh.toString());

  const sayerTax = kalaItem?.kalaName?.mablaghSayerTax || 0;
  const sayerGhanooni = kalaItem?.kalaName?.mablaghSayerGhanooni || 0;

  kalaItem.priceSayerTaxAvarez = formatNumber(sayerTax.toString());
  kalaItem.priceSayerGhanoni = formatNumber(sayerGhanooni.toString());

  let priceTotal = priceArzesh + priceAfter + sayerGhanooni + sayerTax;

  kalaItem.priceTotal = formatNumber(priceTotal.toString());

  return kalaItem;
}; 



export const CalculateKala2 = (kalaItem) => {
  let price = removeFormat(kalaItem.kalaPrice) * kalaItem.kalaTedad;
  let priceAfter = price - removeFormat(kalaItem.priceDiscount);
  let priceArzesh = (kalaItem.arzeshAfzodeh * price) / 100;

  kalaItem.priceBeforeDiscount = formatNumber(price.toString());
  kalaItem.priceAfterDiscount = formatNumber(priceAfter.toString());
  kalaItem.priceTaxArzeshAfzodeh = formatNumber(priceArzesh.toString());

  let priceTotal =
    priceArzesh +
    priceAfter + 
   Number(removeFormat(kalaItem.priceSayerGhanoni)) +
   Number(removeFormat(kalaItem.priceSayerTaxAvarez));
  kalaItem.priceTotal = formatNumber(priceTotal.toString());
  
  return kalaItem;
};

export const CalculateTotalBeforeDiscount = (kalaItems) => {
  return formatNumber(
    kalaItems
      .reduce(
        (acc, curr) => acc + Number(removeFormat(curr.priceBeforeDiscount)),
        0
      )
      .toString()
  );
};
export const CalculateTotalDiscount = (kalaItems) => {
  return formatNumber(
    kalaItems
      .reduce((acc, curr) => acc + Number(removeFormat(curr.priceDiscount)), 0)
      .toString()
  );
};
export const CalculateTotalAfterDiscount = (kalaItems) => {
  return formatNumber(
    kalaItems
      .reduce(
        (acc, curr) => acc + Number(removeFormat(curr.priceAfterDiscount)),
        0
      )
      .toString()
  );
};
/* export const CalculateTotalArzeshAfzodeh = (kalaItems) => {
  return formatNumber(
    kalaItems
      .reduce(
        (acc, curr) => acc + Number(removeFormat(curr.priceTaxArzeshAfzodeh)),
        0
      )
      .toString()
  );
}; */
export const CalculateTotalArzeshAfzodeh = (kalaItems) => {
  const total = kalaItems.reduce(
    (acc, curr) =>
      acc + Number(removeFormat(curr.priceTaxArzeshAfzodeh)),
    0
  );

  return formatNumber(Math.round(total).toString());
};
export const CalculateTotalSayerTaxAvarez = (kalaItems) => {
  return formatNumber(
    kalaItems
      .reduce(
        (acc, curr) =>
          acc +
          Number(removeFormat(curr.priceSayerTaxAvarez)) +
          Number(removeFormat(curr.priceSayerGhanoni)),
        0
      )
      .toString()
  );
};
/* export const CalculateTotal = (kalaItems) => {
  return formatNumber(
    kalaItems
      .reduce((acc, curr) => acc + Number(removeFormat(curr.priceTotal)), 0)
      .toString()
  );
}; */
export const CalculateTotal = (kalaItems) => {
  const total = kalaItems.reduce(
    (acc, curr) => acc + Number(removeFormat(curr.priceTotal)),
    0
  );

  return formatNumber(Math.round(total).toString());
};
 
export const base64ToArrayBuffer = (base64) => {
  if (base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
  return null

}

export const downloadBinaryFile = (binaryData, fileName, fileType) => {
  let blobData = undefined;
  if (fileType) {
    blobData = new Blob([binaryData], { type: fileType })
  } else {
    blobData = new Blob([binaryData])
  }
  const url = window.URL.createObjectURL(blobData);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}